export const consultationTableAdditionalColumnsKeys = {
    parents: 'parents',
} as const;
